import React, { useEffect } from "react";

export const Navigation = (props) => {
  useEffect(() => {
    const links = document.querySelectorAll('.navbar-collapse .nav a');
    links.forEach(link => {
      link.addEventListener('click', () => {
        const nav = document.querySelector('.navbar-collapse');
        if (nav.classList.contains('in')) {
          nav.classList.remove('in');
          nav.classList.add('collapse');
        }
      });
    });
  }, []);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container-fluid">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <img src="/img/logo.jpeg" alt="Grupo VENDITEK" style={{ height: '40px' }} />
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li><a href="#features" className="page-scroll">Caracteristicas</a></li>
            <li><a href="#about" className="page-scroll">Acerca de</a></li>
            <li><a href="#services" className="page-scroll">Servicios</a></li>
            <li><a href="#portfolio" className="page-scroll">Galeria</a></li>
            <li><a href="#marcas" className="page-scroll">Marcas</a></li>
            <li><a href="#map" className="page-scroll">Mapa</a></li>
            <li><a href="#contact" className="page-scroll">Contacto</a></li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
